var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import { styled } from '../../themeCustomink';
import { Button } from '@mui/material';
var ToggleButtonStyles = styled(Button, {
  name: 'swatchgroup-toggle-button'
})({
  backgroundColor: 'transparent',
  boxSizing: 'border-box',
  borderBottom: "1px dashed ".concat(designTokens.color.gray.slateDefault.value),
  borderRadius: '0px',
  color: designTokens.color.gray.slateDefault.value,
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '600',
  height: 'unset',
  lineHeight: '125%',
  margin: 'auto auto auto 0',
  minWidth: 'initial',
  padding: '0',
  whiteSpace: 'nowrap',
  gridColumn: 'span 2',
  '&:hover': {
    backgroundColor: 'transparent',
    borderBottom: "1px dashed ".concat(designTokens.color.gray.obsidian.value),
    color: designTokens.color.gray.obsidian.value
  },
  '&:focus': {
    backgroundColor: 'transparent',
    color: designTokens.color.gray.obsidian.value
  }
});
export var ToggleButton = function (_a) {
  var count = _a.count,
    props = __rest(_a, ["count"]);
  return /*#__PURE__*/React.createElement(ToggleButtonStyles, __assign({}, props), "+", count, " color", count > 1 ? 's' : '');
};